var _defs, _rect, _path, _path2, _polygon, _polygon2, _path3, _polygon3, _path4, _polygon4, _polygon5, _path5, _path6, _polygon6, _polygon7, _polygon8, _path7, _path8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _path9, _polygon9, _polygon10, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituation5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "situation_5_zoom\\xE9e",
    "data-name": "situation 5 zoom\\xE9e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2926.74 3001.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b0b0b0;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_99);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_99-2);}.cls-4{fill:#d3d3d3;}.cls-5{fill:#aaa;}.cls-6{fill:#828282;}.cls-7{fill:#939393;}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_107);}.cls-9{fill:#4f4f4f;}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_174);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_121);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_99-3);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_99-4);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_99-5);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_99-6);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_99-7);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_99-8);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_99-9);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_99-10);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_99-11);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_99-12);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_99-13);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_99-14);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_99-15);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_99-16);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_99-17);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_99-18);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_99-19);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_99-20);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_99-21);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_99-22);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_99-23);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_99-24);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_99-25);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_99-26);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_99-27);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_99-28);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_99-29);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_99-30);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_99-31);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_99-32);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_99-33);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_99-34);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_99-35);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_99-36);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_99-37);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_99-38);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_99-39);}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_99-40);}.cls-50{fill:url(#D\xE9grad\xE9_sans_nom_107-2);}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_132);}.cls-52{fill:none;}.cls-53{fill:url(#D\xE9grad\xE9_sans_nom_99-41);}.cls-54{fill:url(#D\xE9grad\xE9_sans_nom_107-3);}.cls-55{fill:url(#D\xE9grad\xE9_sans_nom_165);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99",
    x1: 1800.06,
    y1: 0.46,
    x2: 1800.06,
    y2: 1681.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-2",
    x1: 782.96,
    y1: 161.52,
    x2: 782.96,
    y2: 1697.25,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_107",
    x1: 894.27,
    y1: 1308.38,
    x2: 894.27,
    y2: 1384.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_174",
    x1: 1613.83,
    y1: 2303.16,
    x2: 1613.83,
    y2: 3000.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_121",
    x1: 522.98,
    y1: 190.1,
    x2: 580.11,
    y2: 174.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1a1a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-3",
    x1: 573.01,
    y1: 379.26,
    x2: 573.01,
    y2: 2999.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-4",
    x1: 811.51,
    y1: 1364.35,
    x2: 811.51,
    y2: 2999.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-5",
    x1: 714.38,
    y1: 732.85,
    x2: 714.38,
    y2: 1424.09,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-6",
    x1: 712.06,
    y1: 840.88,
    x2: 712.06,
    y2: 1525.49,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-7",
    x1: 710.36,
    y1: 965.42,
    x2: 710.36,
    y2: 1583.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-8",
    x1: 708.93,
    y1: 1078.47,
    x2: 708.93,
    y2: 1628.74,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-9",
    x1: 707.43,
    y1: 1183.18,
    x2: 707.43,
    y2: 1681.26,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-10",
    x1: 706,
    y1: 1295.25,
    x2: 706,
    y2: 1726.68,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-11",
    x1: 704.77,
    y1: 1400.37,
    x2: 704.77,
    y2: 1762.89,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-12",
    x1: 703.59,
    y1: 1510.97,
    x2: 703.59,
    y2: 1793.67,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-13",
    x1: 702.51,
    y1: 1610.62,
    x2: 702.51,
    y2: 1822.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-14",
    x1: 701.95,
    y1: 1697.39,
    x2: 701.95,
    y2: 1857.1,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-15",
    x1: 700.27,
    y1: 1793.67,
    x2: 700.27,
    y2: 1891.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-16",
    x1: 699.32,
    y1: 1857.1,
    x2: 699.32,
    y2: 1926.01,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-17",
    x1: 698.2,
    y1: 1936.85,
    x2: 698.2,
    y2: 1960.15,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-18",
    x1: 696.36,
    y1: 1984.01,
    x2: 696.36,
    y2: 1992.96,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-19",
    x1: 697.41,
    y1: 2012.93,
    x2: 697.41,
    y2: 2055.14,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-20",
    x1: 695.57,
    y1: 2046.65,
    x2: 695.57,
    y2: 2121.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-21",
    x1: 694.89,
    y1: 2074.8,
    x2: 694.89,
    y2: 2184.86,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-22",
    x1: 693.78,
    y1: 2116.46,
    x2: 693.78,
    y2: 2255.05,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-23",
    x1: 692.96,
    y1: 2143.62,
    x2: 692.96,
    y2: 2316.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-24",
    x1: 692.12,
    y1: 2169.55,
    x2: 692.12,
    y2: 2384.18,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-25",
    x1: 691.66,
    y1: 2197.98,
    x2: 691.66,
    y2: 2441.86,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-26",
    x1: 690.46,
    y1: 2227.85,
    x2: 690.46,
    y2: 2501.08,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-27",
    x1: 690.12,
    y1: 2248.31,
    x2: 690.12,
    y2: 2563.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-28",
    x1: 688.41,
    y1: 2293.21,
    x2: 688.41,
    y2: 2661.49,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-29",
    x1: 687.09,
    y1: 2335.3,
    x2: 687.09,
    y2: 2764.78,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-30",
    x1: 685.5,
    y1: 2389.66,
    x2: 685.5,
    y2: 2880.34,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-31",
    x1: 684.11,
    y1: 2431.76,
    x2: 684.11,
    y2: 2994.51,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-32",
    x1: 700.62,
    y1: 2488.83,
    x2: 700.62,
    y2: 2999.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-33",
    x1: 716.63,
    y1: 2550.04,
    x2: 716.63,
    y2: 3000.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-34",
    x1: 729.63,
    y1: 2611.22,
    x2: 729.63,
    y2: 3000.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-35",
    x1: 741.64,
    y1: 2672.37,
    x2: 741.64,
    y2: 3000.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-36",
    x1: 752.21,
    y1: 2729.49,
    x2: 752.21,
    y2: 3000.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-37",
    x1: 761.97,
    y1: 2805.62,
    x2: 761.97,
    y2: 3000.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-38",
    x1: 769.09,
    y1: 2860.02,
    x2: 769.09,
    y2: 3000.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-39",
    x1: 775.79,
    y1: 2940.14,
    x2: 775.79,
    y2: 2999.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-40",
    x1: 778.48,
    y1: 3032.4,
    x2: 778.48,
    y2: 3032.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_107-2",
    x1: 687.17,
    y1: 0.5,
    x2: 687.17,
    y2: 161.57,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_107"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_132",
    x1: 1154.5,
    y1: 2441.86,
    x2: 1154.5,
    y2: 3000.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_99-41",
    x1: 817.05,
    y1: 35.83,
    x2: 817.05,
    y2: 1358.57,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_107-3",
    x1: 848.58,
    y1: 36.25,
    x2: 848.58,
    y2: 162.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_107"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_165",
    x1: 784.45,
    y1: 152.58,
    x2: 784.45,
    y2: 1358.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "situation 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 921.16,
    y: 1681.26,
    width: 372.84,
    height: 760.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2924.55.46S1288.43,1681.24,1293,1681.22H976.83L675.58.46Z",
    transform: "translate(1 0.04)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M923.14,1696.14s37.29,4.47,49.22-4.48a119.06,119.06,0,0,0,20.88-20.88L957,1310.29,840.71,163.43l-268-1.91V379.26L835.15,1377Z",
    transform: "translate(1 0.04)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1324.04 2265.58 2091.5 3000.54 1933.5 3000.54 1294 2301.68 1294 2265.88 1324.04 2265.58"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1294 2265.58 2026.5 3000.54 1933.5 3000.54 1294 2301.67 1294 2265.58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M965.84,1693.65,675.58,161.52H569.69V379.26L920.16,1696.14S950.38,1700.11,965.84,1693.65Z",
    transform: "translate(1 0.04)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.24 0.5 396.2 425.54 368.95 3000.54 421.9 3000.54 448.4 433 300.75 0.5 217.24 0.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M835.15,1377s31.32,11.94,71.59,6c19.39-9,52.2-52.2,47.72-74.57H833.66Z",
    transform: "translate(1 0.04)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0.99 0.5 217.24 0.5 396.2 425.54 368.5 3000.54 0.5 2999.54 0.99 0.5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "921.16 2441.86 921.16 1697.67 473.75 0.5 300.75 0.5 448.4 433 421.5 3000.54 791.5 2999.54 921.16 2441.86"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1039.47,2046.61",
    transform: "translate(1 0.04)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M896.1,1308.79",
    transform: "translate(1 0.04)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "573.67 379.31 573.67 161.57 669.12 161.57 889.24 1308.42 834.66 1308.42 834.66 1365.1 573.67 379.31"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1517.5 3000.54 1294 2441.86 1294 2303.16 1933.66 3000.4 1517.5 3000.54"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "573.67 161.57 533.41 0.5 473.75 0.5 573.67 379.31 573.67 161.57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M572.67,379.26,545.5,2999.5h23l31-2515.81C602.5,425.5,600.26,402.57,572.67,379.26Z",
    transform: "translate(1 0.04)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M832.3,1364.35,778.5,2999.5h10l55.63-1597.14C845.59,1384.44,843.09,1377.1,832.3,1364.35Z",
    transform: "translate(1 0.04)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 831.36,
    y1: 1424.09,
    x2: 597.39,
    y2: 732.85
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 828.07,
    y1: 1525.49,
    x2: 596.06,
    y2: 840.88
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 826.18,
    y1: 1583.54,
    x2: 594.53,
    y2: 965.42
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 824.71,
    y1: 1628.74,
    x2: 593.14,
    y2: 1078.47
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 823,
    y1: 1681.26,
    x2: 591.86,
    y2: 1183.18
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 821.52,
    y1: 1726.68,
    x2: 590.48,
    y2: 1295.25
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 820.35,
    y1: 1762.89,
    x2: 589.19,
    y2: 1400.37
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 819.35,
    y1: 1793.67,
    x2: 587.84,
    y2: 1510.97
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 818.4,
    y1: 1822.7,
    x2: 586.61,
    y2: 1610.62
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 817.28,
    y1: 1857.1,
    x2: 586.61,
    y2: 1697.39
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 816.16,
    y1: 1891.55,
    x2: 584.37,
    y2: 1793.67
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 815.04,
    y1: 1926.01,
    x2: 583.59,
    y2: 1857.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 813.78,
    y1: 1960.15,
    x2: 582.61,
    y2: 1936.85
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 810.8,
    y1: 1984.01,
    x2: 581.92,
    y2: 1992.96
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 812.22,
    y1: 2012.93,
    x2: 582.61,
    y2: 2055.14
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 810.8,
    y1: 2046.65,
    x2: 580.34,
    y2: 2121.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 810.21,
    y1: 2074.8,
    x2: 579.56,
    y2: 2184.86
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 808.85,
    y1: 2116.46,
    x2: 578.7,
    y2: 2255.05
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 807.97,
    y1: 2143.62,
    x2: 577.95,
    y2: 2316.22
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 807.13,
    y1: 2169.55,
    x2: 577.12,
    y2: 2384.18
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 806.2,
    y1: 2197.98,
    x2: 577.12,
    y2: 2441.86
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 805.23,
    y1: 2227.85,
    x2: 575.68,
    y2: 2501.08
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 804.57,
    y1: 2248.31,
    x2: 575.68,
    y2: 2563.6
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 803.11,
    y1: 2293.21,
    x2: 573.71,
    y2: 2661.49
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 801.74,
    y1: 2335.3,
    x2: 572.45,
    y2: 2764.78
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 799.97,
    y1: 2389.66,
    x2: 571.03,
    y2: 2880.34
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 798.6,
    y1: 2431.76,
    x2: 569.63,
    y2: 2994.51
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 796.74,
    y1: 2488.83,
    x2: 604.5,
    y2: 2999.54
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 794.75,
    y1: 2550.04,
    x2: 638.5,
    y2: 3000.54
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 792.77,
    y1: 2611.22,
    x2: 666.5,
    y2: 3000.54
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 790.78,
    y1: 2672.37,
    x2: 692.5,
    y2: 3000.54
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 788.92,
    y1: 2729.49,
    x2: 715.5,
    y2: 3000.54
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 786.45,
    y1: 2805.62,
    x2: 737.5,
    y2: 3000.54
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 784.68,
    y1: 2860.02,
    x2: 753.5,
    y2: 3000.54
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: 782.07,
    y1: 2940.14,
    x2: 769.5,
    y2: 2999.54
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M778.48,3032.4",
    transform: "translate(1 0.04)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "573.67 161.57 533.72 0.5 821.24 0.5 840.63 161.57 573.67 161.57"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "921.16 2441.86 1294 2441.86 1517.5 3000.54 791.5 2999.54 921.16 2441.86"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M842.61,1380s56.67,10.44,70.09,0,40.64-35,44.18-71.18",
    transform: "translate(1 0.04)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1018.18,1283c-1.08-9,14.91-1245.29,14.91-1245.29l-268-1.91L668.12,158.54s16.85,88.19,41.4,216.59c-16-.34-60.79-4.81-108.51-7.8.64,3.34,1.49,22.37,3,44.74,46.24,3,98.43,7.46,114.32,9,57.42,300.31,146.7,767.08,171.45,895.15-8.37,1.07-18.81,2.56-30.74,2.56.27,1.44,1.49,7.46,1.49,10.44,11.93,0,22.37-1.49,29.82-1.49a151.44,151.44,0,0,0,6,22c10.44,6.39,50.71,12.35,71.59,6.39C990.26,1345.67,1017.1,1306.89,1018.18,1283Z",
    transform: "translate(1 0.04)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M668.12,158.54s222.68,13.7,252-8.95S972.36,94.41,1029,36.25H762.08Z",
    transform: "translate(1 0.04)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M915.69,152.58c-42,14.36-145.5,9.85-247.57,6,0,0,16.85,88.19,41.4,216.59-16-.34-60.79-4.81-108.51-7.8.64,3.34,1.49,22.37,3,44.74,46.24,3,98.43,7.46,114.32,9,57.42,300.31,146.7,767.08,171.45,895.15-8.37,1.07-18.81,2.56-30.74,2.56.27,1.44,1.49,7.46,1.49,10.44,11.93,0,22.37-1.49,29.82-1.49a151.44,151.44,0,0,0,6,22c10.44,6.39,50.71,12.35,71.59,6.39C963.41,1324.79,915.69,152.58,915.69,152.58Z",
    transform: "translate(1 0.04)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituation5);
export default __webpack_public_path__ + "static/media/situation_5.fcacab1634cc44c50caeb483acf8cbca.svg";
export { ForwardRef as ReactComponent };